import { Component } from 'react';
import { Shield, RotateCcw } from 'lucide-react';

const SESSION_KEY = 'portal_session';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    handleReset = () => {
        // Clear stale session so ProtalProvider remounts cleanly
        // and LookupPage doesn't redirect to a dead /manage page.
        sessionStorage.removeItem(SESSION_KEY);
        this.setState({ hasError: false, error: null });
    };

    handleReturnToLogin = () => {
        sessionStorage.removeItem(SESSION_KEY);
        window.location.href = '/lookup';
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center bg-gray-50 dark:bg-zinc-950">
                    <Shield className="w-12 h-12 text-red-400 mb-4" />
                    <h1 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100 mb-2">
                        Something went wrong
                    </h1>
                    <p className="text-sm text-zinc-500 dark:text-zinc-400 mb-6 max-w-md">
                        An unexpected error occurred. Please try again or return to the login page.
                    </p>
                    <div className="flex gap-3">
                        <button
                            type="button"
                            onClick={this.handleReset}
                            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-zinc-700 dark:text-zinc-200 bg-zinc-100 dark:bg-zinc-800 border border-zinc-300 dark:border-zinc-600 rounded-lg hover:bg-zinc-200 dark:hover:bg-zinc-700 transition-colors"
                        >
                            <RotateCcw className="w-4 h-4" />
                            Try Again
                        </button>
                        <a
                            href="/lookup"
                            onClick={(e) => {
                                e.preventDefault();
                                this.handleReturnToLogin();
                            }}
                            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
                        >
                            Return to Login
                        </a>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
